import { Button } from '@material-ui/core'
import React, { useContext } from 'react'
import { Link, NavLink } from 'react-router-dom'
import HowBidPopup from '../../../Component/HowBiddingWorks'
import { Copyrightinfo, Logo } from '../../../utils'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import AuthContext from '../../../Product/context/auth/authContext'
import './Footer.css'
import Footernav from '../../../utils/FooterNavigation/footernav'
function Footer() {
    const contactEmail = global?.storeDetails?.contact_email
    const contactPhone = global?.storeDetails?.phone
    const facebookLink = global?.storeDetails?.facebook
    const twitterLink = global?.storeDetails?.twitter
    const googleLink = global?.storeDetails?.google
    const instagramLink = global?.storeDetails?.instagram

    const [hbid, setHBid] = React.useState(false)

    const { user, isAuthenticated, logout } = useContext(AuthContext)

    const forMobile = useMediaQuery('(max-width:1024px)')

    return (
        <footer className="footer-main-standard noPrint">
            <div className="customContainer">
                <div className="row" data-gutter="60">
                    <div className="col-12 ftrDtlCntnr">
                        <div className="footLogoCnt">
                            <Logo className="footerLogo" />
                            {!forMobile && <Copyrightinfo />}
                        </div>
                        <div className="footerMisc">
                            <ul className="footerLinks">
                                {/* <li onClick={() => setHBid(true)}>
                                        <a className="cursorDecoy">How does bidding work</a>
                                    </li> */}
                                <li>
                                    <NavLink activeClassName="active" to="/how_it_works">
                                        How It Works
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink activeClassName="active" to="/termsOfService">
                                        Terms & Conditions
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink activeClassName="active" to="/privacy_policy">
                                        Privacy Policy
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink activeClassName="active" to="/faq">
                                        FAQs
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink activeClassName="active" to="/aboutus">
                                        About Us
                                    </NavLink>
                                </li>
                                <Footernav />
                            </ul>

                            <ul className="footer-main-standard-social-list">
                                {facebookLink && (
                                    <li className="facebook">
                                        <a
                                            href={facebookLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title="Facebook"
                                        >
                                            <i className="fab fa-facebook"></i>
                                        </a>
                                    </li>
                                )}
                                {facebookLink && (
                                    <li className="pinterest">
                                        <a
                                            href={twitterLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title="Pinterest"
                                        >
                                            <i className="fab fa-twitter"></i>
                                        </a>
                                    </li>
                                )}
                                {googleLink && (
                                    <li className="instagram">
                                        <a
                                            href={googleLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title="Instagram"
                                        >
                                            <i className="fab fa-linkedin"></i>
                                        </a>
                                    </li>
                                )}
                                {instagramLink && (
                                    <li className="instagram">
                                        <a
                                            href={instagramLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title="Instagram"
                                        >
                                            <i className="fab fa-instagram"></i>
                                        </a>
                                    </li>
                                )}
                            </ul>
                        </div>
                        {forMobile && <Copyrightinfo />}
                    </div>
                </div>
            </div>
            <HowBidPopup open={hbid} handleClose={() => setHBid(false)} />
            {/* forMobile */}
        </footer>
    )
}

export default Footer
